var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49994 0.0859985L5.99994 4.586L10.4999 0.0859985L11.9139 1.5L7.41394 6L11.9139 10.5L10.4999 11.914L5.99994 7.414L1.49994 11.914L0.0859375 10.5L4.58594 6L0.0859375 1.5L1.49994 0.0859985Z",
    fill: "#505877"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossGrey);
export default __webpack_public_path__ + "static/media/cross_grey.abd51ec95b5e4a4eb5ee70eb273a6f64.svg";
export { ForwardRef as ReactComponent };